import config from "config/config"
import axios from "axios"

import * as url from "../helpers/url_helper"

export const generateReports = {
  getReportGenerated: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.Generate_Report}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }

    return await axios(axiosConfig)
  },

  getAllExams: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.GET_ALL_EXAMS}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }

    return await axios(axiosConfig)
  },
}
